import { mapActions, mapGetters } from 'vuex';

//---helpers
import { BLOG_NEWS_TYPE } from '@/helpers';
import { globalLoader } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import NewsCard from '@/components/cards/NewsCard/index.vue';

export default {
  name: 'News',
  mixins: [dynamicHead],
  components: {
    BreadcrumbsSimple,
    Pagination,
    NewsCard
  },
  props: {},
  data() {
    return {
      newsType: BLOG_NEWS_TYPE.INTERESTING,
      newsData: null,
      newsList: [],
      newsListMeta: null,
      isNewsListLoading: false
    };
  },
  created() {
    let { name } = this.$route;
    if (name.indexOf(BLOG_NEWS_TYPE.NEWS) > -1) {
      this.newsType = BLOG_NEWS_TYPE.NEWS;
    }
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {
    pageTitle() {
      return this.newsType === BLOG_NEWS_TYPE.NEWS ? this.$t('page.news.title') : this.$t('page.interesting.title');
    }
  },
  methods: {
    ...mapActions({
      getBlogNews: 'blog/GET_BLOG_NEWS',
      getBlogInterestingArticles: 'blog/GET_BLOG_INTERESTING_ARTICLES',
      getPage: 'staticPages/GET_PAGE'
    }),
    async _getNewsList() {
      this.isNewsListLoading = true;
      let { page } = this.$route.params;
      let result = null;
      if (this.newsType === BLOG_NEWS_TYPE.NEWS) {
        result = await this.getBlogNews({ page: page ? Number(page) : 1 });
      } else if (this.newsType === BLOG_NEWS_TYPE.INTERESTING) {
        result = await this.getBlogInterestingArticles({ page: page ? Number(page) : 1 });
      }

      this.newsList = result.data;
      this.newsListMeta = result.meta;
      this.isNewsListLoading = false;
    },
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];
      promiseCollection.push(this._getNewsList());
      let metaSlug = this.newsType === BLOG_NEWS_TYPE.NEWS ? 'news' : 'interesnye-stati';
      promiseCollection.push(
        this.getPage(metaSlug).then((data) => {
          this.newsData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection);
      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.newsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
